export const REQUEST = 'RespondentBases/RespondentBases/REQUEST';
export const SUCCESS = 'RespondentBases/RespondentBases/SUCCESS';
export const ERROR = 'RespondentBases/RespondentBases/ERROR';

export const ADDED = 'RespondentBases/RespondentBases/ADDED';
export const DELETED = 'RespondentBases/RespondentBases/DELETED';
export const UPDATED = 'RespondentBases/RespondentBases/UPDATED';